import { useQuery } from 'react-query';
import { adminAxios, publicAxios, secureAxios } from '../../constant/auth';
import { toast } from 'react-toastify';

export const useItems = (collection, preset, enabled) => {
  return useQuery(
    ['items', collection],
    () => secureAxios.get(`/items/${collection}`).then((res) => res.data),
    {
      enabled: enabled,
    },
  );
};

export const useItemsFilter = (
  collection,
  queryString,
  enabled,
  type = '',
  cacheTime = 300000,
) => {
  return useQuery(
    [collection, queryString],
    () =>
      secureAxios
        .get(`/${collection}${queryString ? `${queryString}` : ``}`)
        .then((res) => {
          return type == 'invoice' ? res : res?.data;
        }),
    {
      enabled: enabled,
      cacheTime: cacheTime,
    },
  );
};

export const useUserFilter = (collection, queryString, enabled) => {
  return useQuery(
    ['items', collection, queryString],
    () =>
      secureAxios.get(`${collection}${queryString}`).then((res) => res.data),
    {
      enabled: enabled,
    },
  );
};
export const Editprofiledata = (enabled) => {
  return useQuery(
    ['user_data'],
    () =>
      secureAxios
        .get(
          `/users/me?fields=first_name,last_name,qm_sc_users_personal_details.*`,
        )
        .then((res) => res.data),
    {
      enabled: enabled,
    },
  );
};

export const useUserItemsFilter = (
  collection,
  queryString,
  enabled,
  extraQuery = null,
) => {
  return useQuery(
    ['items', collection, queryString, extraQuery],
    () =>
      secureAxios.get(`${collection}${queryString}`).then((res) => {
        return queryString.includes('filter_count') ? res : res.data;
      }),
    {
      enabled: enabled,
    },
  );
};

export const useUserDataFilter = (
  collection,
  queryString,
  enabled,
  extraQuery = null,
) => {
  return useQuery(
    [collection, queryString, extraQuery],
    () =>
      secureAxios.get(`${collection}${queryString}`).then((res) => {
        return res;
      }),
    {
      enabled: enabled,
    },
  );
};

export const useUsersdata = (collection, enabled) => {
  const query = collection === 'users' ? `${collection}?limit=-1` : collection;
  return useQuery(
    ['items', collection],
    () => adminAxios.get(`/${query}`).then((res) => res.data),
    {
      enabled: enabled,
    },
  );
};

export const useNoticedata = (collection, enabled) => {
  return useQuery(
    ['items', collection],
    () => secureAxios.get(`items/${collection}`).then((res) => res.data),
    {
      enabled: enabled,
    },
  );
};

export const useItemsFilterNew = (
  collection,
  queryString = '',
  enabled,
  callback,
  cacheTime = 300000,
) => {
  return useQuery(
    [collection, queryString],
    () =>
      secureAxios
        .get(`/${collection}${queryString}`)
        .then(callback)
        .catch((err) => err),
    {
      enabled: enabled,
      cacheTime: cacheTime,
      // keepPreviousData: true,
    },
  );
};
